import { z } from 'zod';

/**
 * Admin environment. Validated at module load so a missing key fails the build
 * loudly rather than shipping `undefined` into a fetch URL.
 */
const schema = z.object({
  VITE_API_URL: z.string().url(),
  VITE_PUBLIC_UPLOAD_URL: z.string().url(),
  VITE_SENTRY_DSN: z.string().default(''),
  VITE_SITE_URL: z.string().url(),
});

const parsed = schema.safeParse(import.meta.env);

if (!parsed.success) {
  const lines = parsed.error.issues.map((i) => `  ${i.path.join('.')} — ${i.message}`);
  throw new Error(`Admin environment is not usable:\n${lines.join('\n')}`);
}

export const env = Object.freeze({
  apiUrl: parsed.data.VITE_API_URL.replace(/\/$/, ''),
  uploadUrl: parsed.data.VITE_PUBLIC_UPLOAD_URL.replace(/\/$/, ''),
  sentryDsn: parsed.data.VITE_SENTRY_DSN,
  siteUrl: parsed.data.VITE_SITE_URL.replace(/\/$/, ''),
  isProduction: import.meta.env.PROD,
});
